<template>
  <div>
    <b-row align-h="between">
      <b-col cols="12">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <div
              style="color: #303133;font-size: 14px;line-height: 30px;font-weight: 500;"
            >
              {{
                amzSkuMaterialGroup === 'packaging'
                  ? $l('INDEX.amz_sku_tab_pane_label_packaging') || '包装辅料'
                  : $l('INDEX.amz_sku_tab_pane_label_sewing') || '缝制辅料'
              }}
            </div>
            <div class="mr-2 ml-2">
              <DictCascaderCategory
                v-model="form.detailCategoryCode"
                :placeholder="
                  $l('INDEX.form_placeholder_selectMaterialCategory') ||
                    '请选择物料分类'
                "
                clearable
                filterable
                :show-all-levels="false"
                :sync-codes="true"
                :amzSkuMaterialGroup="amzSkuMaterialGroup"
                @change="onCategoryChange"
              ></DictCascaderCategory>
            </div>
            <b-form-input
              class="search-form ml-2"
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.material_choose_search_new') ||
                  '物料编号/名称/材质/尺寸/客户物料编号 搜索... '
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                    >{{ $l('INDEX.advanced_search') || '高级搜索' }}</b-button
                  >
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" size="small" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.table_label_material_name_chinese_name') ||
                  '物料中文名称'
              "
            >
              <el-input
                v-model="form.materialName"
                :placeholder="
                  $l('INDEX.pe_material_name_chinese_name') ||
                    '请输入物料中文名称'
                "
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.table_label_material_name_english') || '物料英文名称'
              "
            >
              <el-input
                v-model.trim="form.materialNameEn"
                :placeholder="
                  $l('INDEX.table_label_pe_material_name_english') ||
                    '请输入物料英文名称'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_manufacturer') || '物料供应商'"
            >
              <dict-select
                :placeholder="
                  $l('INDEX.table_label_pe_select_manufacturer') ||
                    '请选择物料供应商'
                "
                size="small"
                clearable
                filterable
                v-model="form.scmCode"
                :body="scmParams"
                url="/master/common/dict/scmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.table_label_customerMaterialNo') || '客户物料编号'
              "
            >
              <el-input
                v-model.trim="form.customerMaterialNo"
                :placeholder="
                  $l('INDEX.table_label_pe_customerMaterialNo') ||
                    '请输入客户物料编号'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_selectCustomer') || '所属客户'"
            >
              <dict-select
                :placeholder="
                  $l('INDEX.form_placeholder_selectCustomer') ||
                    '请选择所属客户'
                "
                size="small"
                clearable
                filterable
                v-model="form.custCodeList"
                :body="custParams"
                multiple
                url="/master/common/dict/customerSelect"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_selectBrand') || '品牌'">
              <dict-select
                clearable
                v-model="form.brandCodeList"
                filterable
                multiple
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('INDEX.form_placeholder_selectBrand') || '请选择品牌'
                "
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('INDEX.form_label_select_date') || '选择日期'
                      "
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('INDEX.form_label_select_date') || '选择日期'
                      "
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DictCascaderCategory from '.././dict-cascader-category/index.vue'

// 初始表单

export default {
  components: {
    DictCascaderCategory,
  },
  props: {
    amzSkuMaterialGroup: { type: String, default: '' },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: {
        keyword: '',
        materialStatusList: ['Y'],
        materialOwner: 'ecomAmazon',
        mainCategoryCode:
          this.amzSkuMaterialGroup == 'packaging'
            ? 'd24ddeab-5ee4-41b2-bcc5-b3f3524a83a3'
            : '1ab7e2b2-5b3d-45f9-950a-a552489998e9',
      },
      scmParams: {},
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      productLineParams: { dictType: 'productLine' },
      custParams: {},
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const params = {
        ...this.form,
      }
      this.$emit('query', params)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {
        keyword: '',
        materialStatusList: ['Y'],
        materialOwner: 'ecomAmazon',
        mainCategoryCode:
          this.amzSkuMaterialGroup === 'packaging'
            ? 'd24ddeab-5ee4-41b2-bcc5-b3f3524a83a3'
            : '1ab7e2b2-5b3d-45f9-950a-a552489998e9',
      }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    onCategoryChange(data) {
      this.form.detailCategoryCode = data.detailMaterialCategoryCode || ''
      this.query()
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}

.search-form {
  border-right: none;
}
</style>
